import PostTitle from './PostTitle';

export default PostTitle;
